import { createContext, useContext } from 'react';

const IconPackContext = createContext(null);

export const useIconPack = () => useContext(IconPackContext);

const VIconPackProvider = ({ pack, children }) => (
  <IconPackContext.Provider value={pack}>{children}</IconPackContext.Provider>
);

export default VIconPackProvider;
